import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { User } from 'lucide-react';

function ParentPortalPage() {
  return (
    <div className="space-y-6" data-testid="parent-portal">
      <div>
        <h1 className="font-heading text-2xl font-bold">Portail Parent</h1>
        <p className="text-muted-foreground text-sm">Vue du portail des parents</p>
      </div>
      <Card>
        <CardContent className="py-12 text-center">
          <User className="w-12 h-12 mx-auto mb-4 text-muted-foreground/50" />
          <p className="text-muted-foreground mb-2">Cette page est en construction.</p>
          <p className="text-sm text-muted-foreground">Le portail parent sera bientot disponible.</p>
        </CardContent>
      </Card>
    </div>
  );
}

export default ParentPortalPage;
